import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn as clsx } from "../../helpers/react.js";
import { Font } from "../Font/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index36.css';const tile = "_tile_13zz3_1";
const hovered = "_hovered_13zz3_15";
const disabled = "_disabled_13zz3_15";
const titleBig = "_titleBig_13zz3_31";
const title = "_title_13zz3_31";
const description = "_description_13zz3_33";
const icon = "_icon_13zz3_38";
const texts = "_texts_13zz3_62";
const s = {
  tile,
  hovered,
  disabled,
  titleBig,
  title,
  description,
  icon,
  texts
};
const Tile = withThemeAndSize(
  forwardRef((props, ref) => {
    const { className, type, disabled: disabled2, icon: icon2, titleBig: titleBig2, title: title2, description: description2, hovered: hovered2, ...rest } = props;
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: clsx(s.tile, className, { [s.disabled]: disabled2, [s.hovered]: hovered2 }),
        ...rest,
        disabled: disabled2,
        ref,
        children: [
          icon2 && /* @__PURE__ */ jsx(
            Slot,
            {
              className: clsx(s.icon, {
                [s.disabled]: disabled2
              }),
              children: icon2
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: s.texts, children: [
            titleBig2 && /* @__PURE__ */ jsx(Font, { type: "numerical", size: 20, weight: "regular", children: /* @__PURE__ */ jsx("div", { className: s.titleBig, children: titleBig2 }) }),
            title2 && /* @__PURE__ */ jsx(Font, { type: "text", size: 14, weight: "medium", children: /* @__PURE__ */ jsx("div", { className: s.title, children: title2 }) }),
            description2 && /* @__PURE__ */ jsx(Font, { type: "text", size: 12, weight: "regular", children: /* @__PURE__ */ jsx("div", { className: s.description, children: description2 }) })
          ] })
        ]
      }
    );
  })
);
export {
  Tile
};
